import { Box, Checkbox, Grid, Grow, IconButton, Pagination, Paper, Slide, Stack, Switch, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import AddIcon from "@mui/icons-material/Add";
import styles from "./Popup.module.scss";
import PopupToolbar from '@components/common/toolbar popup';
import classNames from 'classnames';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import ModalConfirmDelete from '@components/ModalConfirmDelete/ModalConfirmDelete';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fetchActivePopupRequest, fetchPopupRequest, fetchPublishPopupRequest } from '@redux/Popup/action';
import { useSelector } from 'react-redux';
import { AppState } from '@configs/store/rootReducer';
import useDebounce from '@components/common/Debounce/useDebounce';
import baseApi from '@redux/Popup/api';

const PopupManagement = ()=>{
    const columnTitle = [
        { name: '' },
        { name: 'Loại Popup' },
        { name: 'Tiêu đề Popup' },
        { name: 'Lượt click' },
        { name: 'Bắt đầu' },
        { name: 'Kết thúc' },
        { name: 'Công bố' }
    ]
    const [list, setList] = useState<any>();
    const [page, setPage] = useState<number>(1);
    const [totalPage, setTotalPage] = useState<number>(0)
    const [selectedArray, setSelectedArray] = useState<any>([]);
    const [keyShowDelete, setKeyShowDelete] = useState(-1);
    const [selectedID, setSelectedID] = useState<any>(null);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [positionFilter, setPositionFilter] = useState<any>();
    const [inpValue, setInpValue] = useState<string>('');
    const [dateStartFilter, setDateStartFilter] = useState<any>();
    const [dateEndFilter, setDateEndFilter] = useState<any>()
    const [popupTypes, setPopupTypes] = useState<any[]>([]);
    const [stateFilter, setStateFilter] = useState<any>({})
    const delayInput = useDebounce(inpValue, 550);
    const { popUp } = useSelector((state: AppState) => state.toPopup);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const loadPopupTypes = async () => {
            try {
                const response = await baseApi.fetchPopupTypes();
                const types = response?.data || [];
                setPopupTypes(types);
                setStateFilter((prev: any) => {
                    const next: any = {};
                    types.forEach((type: any) => {
                        next[type.name] = prev?.[type.name] || false;
                    });
                    return next;
                });
            } catch (error) {
                setPopupTypes([]);
            }
        };
        loadPopupTypes();
    }, []);

    useEffect(() => {
        dispatch(fetchPopupRequest({ params: {  page: page, title: delayInput, 
                                                startDate: dateStartFilter?.toString().split(" ").slice(1, 4).join(" "), 
                                                endDate: dateEndFilter?.toString().split(" ").slice(1, 4).join(" ") ,
                                                popupPosition: positionFilter, }
                                    }))
    }, [delayInput, dateStartFilter, dateEndFilter,positionFilter])
    useEffect(() => {
        setList(popUp)
    }, [popUp, delayInput])
    //=========test=========// auto unpublish when time out
    /**/const [filteredPopupTimeOut, setFilteredPopupTimeOut] = useState<any>([]);
    /**/useEffect(() => {
    /**/    const intervalId = setInterval(() => {
    /**/        const Time = new Date();
    /**/        const currentDate = Time.toString().split(" ").slice(0, 4).join(" ");
    /**/        const currentTime = Time.toLocaleTimeString("vi", {
    /**/            hour: "2-digit",
    /**/            minute: "2-digit",
    /**/        })
    /**/        setFilteredPopupTimeOut(list?.filter((item: any) => item.endDate.endDate <= currentDate && item.endDate.endTime <= currentTime && item.active === true));
    /**/    }, 1000);
    /**/
    /**/    return () => {
    /**/       clearInterval(intervalId);
    /**/    };
    /**/}, [filteredPopupTimeOut]);
    /**/useEffect(() => {
    /**/    if (filteredPopupTimeOut?.length > 0) {
    /**/        const ids = filteredPopupTimeOut.map((item: any) => item._id);
    /**/        // console.log(ids)
    /**/    }
    /**/}, [])
    /**/
    //=========test=========//  WORKED
    const handleClickAdd = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    function ControlledPagination() {
        const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
            setPage(value);
        };

        return (
            <Pagination
                count={totalPage}
                page={page}
                onChange={handleChange}
                variant="outlined"
                shape="rounded"
            />
        );
    }
    const handleToggleSelected = (e: any) => {
        const index = selectedArray.includes(e);
        if (index) {
            const newSelected = selectedArray.filter((item: any) => {
                return item !== e;
            });

            setSelectedArray(newSelected);
            return;
        } else {
            const newSelected = JSON.parse(JSON.stringify(selectedArray));
            newSelected.push(e);
            setSelectedArray(newSelected);
            return;
        }
    };
    const handleShowModalConfirm = (type: any, id?: any) => {
        setIsOpenModal(true);
        setSelectedID(id);
    };
    const handlePreventAndOnClick = (e: any, id: string) => {
        e.preventDefault();
        e.stopPropagation();
        handleToggleSelected(id);
    }
    const handleSelectedAll = () => {
        setSelectedArray(list?.map((li: any) => li._id));
    }

    const handleCloseSelect = () => {
        setSelectedArray([]);
    }
    const handleOnMountEnter = (element: any, index: any) => {
        setKeyShowDelete(index);
        setSelectedID(element?.id);
    };

    const handleOnMountLeave = () => {
        setKeyShowDelete(-1);
    };
    const handleCloseModalConfirm = () => {
        setIsOpenModal(!isOpenModal);
    };

    const handleDeletePost = () => {
        dispatch(fetchActivePopupRequest({id:{id: selectedArray}}));
        setIsOpenModal(!isOpenModal);
        handleCloseSelect();
    };
    const SwitchCell = (props: any) => {
        const { check, disable, onChange } = props
        return (
            <>
                <Switch checked={!!check} disabled={disable} onChange={(event) => onChange?.(event.target.checked, event)} sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                        color: '#41B60B',
                        '&:hover': {
                            backgroundColor: '#41B60B, palette.action.hoverOpacity',
                        },
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: '#41B60B',
                    },
                }}
                />
            </>
        )
    }
    const setPublishPopup =(checked:any, id:any, event:any)=>{
        event.stopPropagation();
        const nextPublished = checked === true;
        setList((prev: any[] = []) => prev.map((item: any) => (
            item?._id === id || item?.id === id
                ? { ...item, published: nextPublished }
                : item
        )));
        dispatch(fetchPublishPopupRequest({params: {id: id, publish: nextPublished}}))
    }
    function formatDate(date: any) {
        const dateFormat = new Date(date); // create a new Date object representing the input date
        return dateFormat.toLocaleDateString('en', { month: '2-digit', day: '2-digit', year: 'numeric' });
    }
    const handleEditClick=(id:any, position:any, event:any)=>{
        dispatch(fetchPopupRequest({params:{id:id}}))
        navigate('/admin/create-popup?type=' + encodeURIComponent(position || '') + '&id=' + id);
    }
    return (
        <div>
            <div className={styles.MenuNavWrapper}>
                <Grid container className={styles.MenuNav} alignItems={"flex-end"}>
                    <Link to="/admin/create-popup">
                        <IconButton
                            aria-label="add"
                            className={styles.AddButton}
                            id="basic-button"
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClickAdd}
                        >
                            <AddIcon style={{ color: "#fff" }} />
                        </IconButton>
                    </Link>

                </Grid>
                <div className={styles.transactionToolbar}>
                    <PopupToolbar
                        anchorEl={undefined}
                        setAnchorEl={undefined}
                        dateStartFilter={dateStartFilter}
                        dateEndFilter={dateEndFilter}
                        setDateStartFilter={setDateStartFilter}
                        setDateEndFilter={setDateEndFilter}
                        setStateFilter={setStateFilter}
                        stateFilter={stateFilter}
                        inputValue={inpValue}
                        setInputValue={setInpValue}
                        setPositionFilter={setPositionFilter}
                        popupTypes={popupTypes}
                    />
                </div>
                <Grid container direction={"column"} className={styles?.Wrapper}>
                    {list?.length > 0 ?
                        <>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#F6F6F7' }}>
                                    <TableRow>
                                        {columnTitle.map((value: any, index: any) => {
                                            return (
                                                <TableCell align="center" key={index}>
                                                    <Typography className={styles.TableCellTitle} sx={{ fontWeight: '600' }}>
                                                        {value.name}
                                                    </Typography>
                                                </TableCell>
                                            )
                                        }
                                        )}
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {list?.map((element: any, index: any) => {
                                        return (
                                            <>
                                                {element.active === true &&
                                                    <TableRow
                                                        key={index}
                                                        className={classNames(
                                                            styles.PaperItem,
                                                            styles.OrderItem,
                                                            selectedArray.includes(element.id) && styles.PaperActive

                                                        )}
                                                        onMouseEnter={() => handleOnMountEnter(element, index)}
                                                        onMouseLeave={handleOnMountLeave}
                                                        onClick={(e) => handleEditClick(element._id, element.popupPosition, e)}
                                                    >
                                                        <TableCell align="right">
                                                            <div
                                                                style={{ width: '20px' }}
                                                                onClick={(e) => {
                                                                    handlePreventAndOnClick(e, element._id);
                                                                }}
                                                            >
                                                                <Grow
                                                                    in={keyShowDelete === index || selectedArray?.length > 0}
                                                                    timeout={1000}
                                                                >
                                                                    <Checkbox
                                                                        color="primary"
                                                                        icon={<RadioButtonUncheckedIcon />}
                                                                        checkedIcon={<RadioButtonCheckedIcon sx={{ color: "#41B60B" }} />}
                                                                        value="checked"
                                                                        checked={selectedArray?.includes(element?._id)}
                                                                        className={styles.CheckboxDeleteMany}
                                                                        onChange={(e: any) => handleToggleSelected(e.target)}
                                                                    />
                                                                </Grow>
                                                            </div>
                                                        </TableCell>
                                                        <TableCell align="center">{element.popupPosition}</TableCell>
                                                        <TableCell align="center">{element.title}</TableCell>
                                                        <TableCell align="center">{element.clicked}</TableCell>
                                                        <TableCell align="center">{formatDate(element.startDate.startDate)} <b>{element.startDate.startTime}</b></TableCell>
                                                        <TableCell align="center">{formatDate(element.endDate.endDate)} <b>{element.endDate.endTime}</b></TableCell>
                                                        {element.isDraft === true ?
                                                            <TableCell align="center" onClick={(e: any) => { e.stopPropagation(); }}>
                                                                <SwitchCell check={false} disable={true} />
                                                            </TableCell>
                                                            :
                                                            <TableCell align="center" onClick={(e: any) => { e.stopPropagation(); }}>
                                                                <SwitchCell
                                                                    check={element.published}
                                                                    disable={false}
                                                                    onChange={(checked: boolean, event: any) => setPublishPopup(checked, element._id, event)}
                                                                />
                                                            </TableCell>

                                                        }
                                                        {/* <TableCell align="center">{new Date(element.startAt || Date.now()).toLocaleDateString('vi')}</TableCell> */}
                                                    </TableRow>
                                                }
                                            </>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </> :
                        <div className={styles.DataEmpty}>Không có dữ liệu</div>
                    }
                    <Grid container display="flex" justifyContent="center" mt={5}>
                        <Stack spacing={2}>
                            <ControlledPagination />
                        </Stack>
                    </Grid>
                </Grid>
            </div>
            <Slide in={selectedArray.length > 0} direction="up">
                <Paper square className={styles.ActionBar}>
                    <Grid
                        container
                        flexDirection={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        sx={{ padding: '0px 10px' }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', cursor: 'pointer' }} onClick={() => handleSelectedAll()}>
                                <RadioButtonCheckedIcon sx={{ color: "#41B60B" }} />
                                <Box sx={{ marginLeft: '10px' }}>Chọn tất cả</Box>
                            </Box>
                            <Box sx={{ marginLeft: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', cursor: 'pointer' }} onClick={() => handleShowModalConfirm("MANY")}>
                                <DeleteOutlineOutlinedIcon />
                                <Box sx={{ marginLeft: '10px' }}>Xóa</Box>
                            </Box>
                        </Box>
                        <Box sx={{ marginLeft: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', cursor: 'pointer', justifySelf: 'flex-end' }} onClick={() => handleCloseSelect()}>
                            <IconButton>
                                <CloseOutlinedIcon />
                            </IconButton>
                        </Box>
                    </Grid>
                </Paper>
            </Slide>
            {isOpenModal && (
                <ModalConfirmDelete
                    onClose={handleCloseModalConfirm}
                    onSubmit={handleDeletePost}
                    title={"Xác Nhận Xóa Popup"}
                />
            )}
        </div>
    )
}
export default PopupManagement;
